// SrcVer: $Id: //trak/main/adhocs/T2023/6/CLRS25/internal/web/system/module/banner/bannerCtrl.js#1 $
'use strict';

/**
* @ngdoc controller
* @name tcApp.controllers:BannerCtrl
* @description
* Top component displays patient banner depending on Global Context variables.
*/

angular.module('tcApp')
.controller('BannerCtrl', function($scope, $route, $sce, $rootScope, $location, $mdSidenav, $log, $timeout,
									GlobalService, OverlayService, IconProfileService, MenuCheckService, $window) {

	var onInit = function() {
		// Show Banner
		$scope.showBanner = true;
		$scope.componentName = 'PAPerson.Banner';
		$scope.componentHtmlName = 'PAPerson_Banner';
	};
	
	var getIconProfileData = function() {
		if (angular.isUndefined($scope.data)) return;
		if (angular.isUndefined($scope.data.listRows)) return;
		if (angular.isUndefined($scope.data.listRows[0])) return;
		var iconProfileItems = ['BANNERIconProfile','BANNERWeightIconProfile','BANNERInfoLinkProfile'];
		var iconProfileObject;
		angular.forEach(iconProfileItems, function(iconProfileItemName) {
			iconProfileObject = $scope.data.listRows[0][iconProfileItemName];
			if (angular.isDefined(iconProfileObject)) {
				IconProfileService.getIconProfileData(iconProfileObject.iconProfileId,
														iconProfileObject.value,
														iconProfileObject,
														$scope.componentName,
														undefined, $scope.context);
			}
		});
		return;
	};

	$scope.getTemplateUrl = function() {
		var url = 'system.Router.cls?TLAYOUT=1&TCOMPONENT=';
		
		if (angular.isDefined($scope.data) && (angular.isDefined($scope.data.componentName))) {
			
			switch ($scope.data.componentName) {
				case 'LBSubject.Banner':
					url = url + 'LBSubject.Banner';
					break;
				case 'PAPerson.Banner':
					url = url + 'PAPerson.Banner';
					break;
			}
		}

		if (angular.isDefined($route.current) && angular.isDefined($route.current.params.CONTEXT)) {
			$scope.context = $route.current.params.CONTEXT;
		}

		if ((angular.isDefined($scope.data)) && (angular.isDefined($scope.data.componentContext))) {
			url += ('&CONTEXT=' + $scope.data.componentContext);
		} else if (angular.isDefined($scope.context) && ($scope.context !== '')) {
			// Pass CONTEXT when retrieving the layout
			url += ('&CONTEXT=' + $scope.context);
		}

		return url;
	};

	$scope.displayHtml = function(value) {
		return $sce.trustAsHtml(value);
	};

	// Catch Global:updated event broadcasted by GlobalService
	var catchUpdateBanner = function(event, data, fromEmbedded) {
		if (!data) {
			data = {};
		}
		if (
			$scope.data
			&& angular.equals(data.items, $scope.data.items)
			&& angular.equals(data.lineData, $scope.data.lineData)
		) {
			// Banner data is the same, don't update it to avoid flickering
			return;
		}
		$scope.data = data;
		$scope.data.listRows = [data.items];
		$scope.globalStrings = GlobalService.getGlobalStrings();
		$scope.showSkipNav = GlobalService.logonData.extraAccessibilitySupport;
		// Manual digest is needed where banner is cleared from embedded TC UI
		if ((fromEmbedded) && (!data.items)) $scope.$apply();
		$timeout(getIconProfileData);
	};

	$scope.$on('Global:updateBanner', catchUpdateBanner);

	$scope.$on('Global:sessionLocked', function() {
		$scope.showBanner = false;
	});
	$scope.$on('Global:sessionUnlocked', function() {
		$scope.showBanner = true;
	});

	$scope.$on('tcMenu:MainMenuSelected', function() {
		$scope.data = {};
	});
	
	var getActionMenuParams = function() {
		var addedParams = {};
		var currentPath = $location.path();
		var pathComponent;

		var callbackAddParams = function(returnParams) {
			var allowedParams = MenuCheckService.actionMenuPassParams();
			angular.forEach(returnParams, function(paramValue, paramKey) {
					if (allowedParams.indexOf(paramKey) !== -1) {
						addedParams[paramKey] = paramValue;
					}
				});
		};
		
		if (currentPath.indexOf('/Component/') === 0) {
			pathComponent = currentPath.split('/Component/')[1];
			if (pathComponent.indexOf('?') !== -1) pathComponent = pathComponent.split('?')[0];
			$rootScope.$broadcast('Component:getComponentBannerMenuParams', pathComponent, false, callbackAddParams);
			
		} else if ((currentPath === '/websys.csp') && (angular.isDefined($window.frames['TRAK_main']))) {
			var embeddedFunctionName = '';
			if (angular.isDefined($window.frames['TRAK_main']['websysCSP_BannerMenuParamsComponent'])) {
				pathComponent = $window.frames['TRAK_main']['websysCSP_BannerMenuParamsComponent'];
				embeddedFunctionName = pathComponent.replace(/\./g, '_') + '_BannerMenuParams';
			}
			if ((embeddedFunctionName !== '') && (angular.isFunction($window.frames['TRAK_main'][embeddedFunctionName]))) {
				callbackAddParams($window.frames['TRAK_main'][embeddedFunctionName]());
			}
		}
		
		return addedParams;
	};
	
	$scope.actionMenuHandler = function($event) {
		// Action menu scope should not change banner scope items
		var listRowData = angular.copy($scope.data.items);
		listRowData._passParameters = $scope.data.items.BANNERPassParameters.value;
		listRowData._passParametersRaw = $scope.data.items.BANNERPassParametersRaw.value;
		switch ($scope.data.componentName) {
			case 'PAPerson.Banner':
				listRowData.EpisodeID = $scope.data.items.BANNEREpisodeID.value;
				listRowData.PatientID = $scope.data.items.BANNERPatientID.value;
				if ((angular.isDefined($scope.data.items.BANNERLBEpisodeID)) && ($scope.data.items.BANNERLBEpisodeID.value !== '')) {
					listRowData.LBEpisodeID = $scope.data.items.BANNERLBEpisodeID.value;
				}
				break;
			case 'LBSubject.Banner':
				listRowData.LBEpisodeID = $scope.data.items.BANNERLBEpisodeID.value;
				listRowData.LBSubjectID = $scope.data.items.BANNERLBSubjectID.value;
				break;
		} 
		var additionalParams = getActionMenuParams();
		if (Object.keys(additionalParams).length > 0) {
			angular.extend(listRowData, additionalParams);
			
			var currentParams = GlobalService.urlToObject(listRowData._passParametersRaw);
			var modifiedParams = angular.extend({}, currentParams, additionalParams);
			if (!angular.equals(currentParams, modifiedParams)) {
				var newLink = '?a=1';
				delete modifiedParams['?a'];
				angular.forEach(modifiedParams, function(paramValue, paramKey) {
						newLink += ('&' + paramKey + '=' + paramValue);
					});
				listRowData._passParametersRaw = newLink;
				newLink = GlobalService.maskUrl(newLink);
				newLink = newLink.split('?')[1];
				listRowData._passParameters = newLink;
			}
		}
		
		// Pass current values/state of items/links to the action menu
		// Same logic as componentCtrl
		['_actionHeaders','_actionLinks','_actionItems'].forEach(function(actionItemKey) { //eslint-disable-line
			if (angular.isDefined(listRowData[actionItemKey])) {
				angular.forEach(listRowData[actionItemKey], function(actionItem, actionItemIndex, actionItems) {
					var itemName = actionItem.name;
					var responsiveDisplayForActionMenu = actionItem.responsiveDisplayForActionMenu;
					if (angular.isDefined(listRowData[itemName])) {
						actionItems[actionItemIndex] = listRowData[itemName];
						actionItems[actionItemIndex].name = itemName;
						if (angular.isDefined(responsiveDisplayForActionMenu)) {
							actionItems[actionItemIndex].responsiveDisplayForActionMenu = responsiveDisplayForActionMenu;
						}
					}
				});
			}
		});
		
		var actionMenuData = {
			componentHtmlName: $scope.componentHtmlName,
			componentName: $scope.componentName,
			listRow: listRowData,
			translations: $scope.data.translations,
			rowIndex: 0,
			triggeringElement: $event.currentTarget,
			hideItemsWithNoData: true
		};
		$mdSidenav('actionMenu').open()
			.then(function() {
				GlobalService.onModalToggle(true);	
				$rootScope.$broadcast('System:focusActionMenu');
			});
		$mdSidenav('actionMenu', true).onClose(function actionMenuCloseHandler() {
			$rootScope.$broadcast('Component:recalcDynamicColumns');
			$mdSidenav('actionMenu').onClose(angular.noop);
		});
		$rootScope.$broadcast('System:updateActionMenu', actionMenuData);
	};
	
	$scope.PhotoClickHandler = function(customItem, $event) {
		var params = '&PatientID=' + customItem.patientId;
		OverlayService.open({
			event: $event,
			componentName: 'PAPerson.PhotoOverlay',
			params: params,
			parentComponentName: $scope.componentName,
			focusHandler: GlobalService.focusFirst
		});
	};
	
	$scope.skipNav = function($event) {
		if ($event) {
			$event.preventDefault();
			$event.stopImmediatePropagation();
		}
		GlobalService.focusFirst(false, true);
	};
	
	onInit();
});
